export const MAIN_COLUMN_MAX_WIDTH_PX = 850;
export const MAIN_COLUMN_ITEMS_SPACING_PX = 32;
export const CARD_ITEM_LEFT_ICON_SIZE_PX = 54;